import React, {useEffect, useState} from "react";
import {TextInput, TouchableOpacity, View, StyleSheet} from "react-native";
import {Picker} from "@react-native-community/picker";
import PtIcon from "../core/pt-icon/pt-icon";
import {styleVars} from "../../app-style-vars";

export default function PtDuePaymentsSearch(props:any) {

  const searchContainerStyle = props.show ? styles.searchContainerShown : null;
  const searchOptions = props.searchOptions || [];

  const initialSelection = props.requestParams.searchType;
  const initialSearchValue = props.requestParams.searchTerm || '';

  const [duePaymentsSearchType, setDuePaymentsSearchType] = useState(initialSelection);
  const [duePaymentsSearchValue, setDuePaymentsSearchValue] = useState(initialSearchValue);


  useEffect(() => {
    if(props.searchTypeChangedHandler) {
      setDuePaymentsSearchType(initialSelection);
    }
    if(props.searchTermChangedHandler) {
      setDuePaymentsSearchValue(initialSearchValue);
    }
  })

  const doSearch = () => {
    if(props.searchHandler) {
      props.searchHandler();
    }
  }

  const searchTypeChanged = (newVal:any) => {
    if(props.searchTypeChangedHandler) {
      props.searchTypeChangedHandler({searchType: newVal});
    } else {
      setDuePaymentsSearchType(newVal);
    }
  }

  const searchTermChanged = (newVal:any) => {
    console.log('the e on text input changed = ', newVal);
    if(props.searchTermChangedHandler) {
      props.searchTermChangedHandler({searchTerm: newVal})
    } else {
      setDuePaymentsSearchValue(newVal);
    }
  }

  return (
    <View style={[styles.searchContainer, searchContainerStyle]}>
      <Picker
        selectedValue={duePaymentsSearchType}
        style={[styles.picker]}
        onValueChange={(itemValue) => searchTypeChanged(itemValue)}
      >
        {searchOptions.map((option:any, idx:number) => (
          <Picker.Item value={option.value} label={option.label} key={idx}/>
        ))}
      </Picker>


      <View style={[styles.searchInputContainer]}>
        <TextInput
          style={[styles.searchInput]}
          onChangeText={(text) => searchTermChanged(text)}
          value={duePaymentsSearchValue}
        />

        <TouchableOpacity onPress={() => doSearch()}>
          <View style={[styles.searchButton]}>
            <PtIcon iconName={'search'} iconSize={24} iconColor={styleVars.boschDarkBlue}/>
          </View>
        </TouchableOpacity>
      </View>


    </View>
  )
}

const styles = StyleSheet.create({
  searchContainer: {
    paddingVertical: styleVars.rem(.5),
    display: 'none',
  },
  searchContainerShown: {
    display: 'flex',
  },
  picker: {
    borderColor: styleVars.boschLightGray,
    borderWidth: 0,
    borderBottomWidth: 1,
    height: styleVars.rem(2.5),
    backgroundColor: '#fff',
  },
  searchInputContainer: {
    paddingVertical: styleVars.rem(.5),
  },
  searchInput: {
    height: 40,
    borderWidth: 0,
    borderBottomWidth: 1,
    borderColor: styleVars.boschLightGray,
    paddingRight: 48,
    paddingLeft: 8,
  },
  searchButton: {
    width: styleVars.rem(2.5),
    height: styleVars.rem(2.5),
    backgroundColor: 'transparent',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    right: 0,
    top: styleVars.rem(-2.5),
  }
})